/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { useLayoutEffect, useRef, useState } from 'react';

import { Locale, LocaleKeys } from '../../../../core/locale';

interface DescriptionInfoProps {
    description?: string;
}

const DescriptionInfo = ({ description }: DescriptionInfoProps) => {
    const displayedDescription =
        description || Locale.getString(LocaleKeys.DESCRIPTION_NOT_AVAILABLE);
    const descriptionRef = useRef<HTMLDivElement>(null);
    const [shouldTrimDescription, setShouldTrimDescription] = useState(false);

    useLayoutEffect(() => {
        if (!descriptionRef.current || !displayedDescription) return;

        let attempts = 0;
        const maxAttempts = 10;

        const checkHeight = () => {
            const contentHeight = descriptionRef.current?.clientHeight || 0;

            if (contentHeight > 0) {
                setShouldTrimDescription(contentHeight > 144);
            } else if (attempts < maxAttempts) {
                attempts += 1;
                requestAnimationFrame(checkHeight);
            }
        };

        checkHeight();
    }, [displayedDescription]);

    return (
        <div
            className={`content-airing-info program-description ${shouldTrimDescription ? 'trimmed' : ''}`}
            data-testid="preview-description"
            ref={descriptionRef}
        >
            <span className={`description-wrapper`}>{displayedDescription}</span>
        </div>
    );
};

export default DescriptionInfo;
